import styled from "styled-components";

export const NavContainer = styled.nav`
  a.leftNavbarBrand {
    display: flex;
    align-items: center;
  }
  span.title {
    font-size: 24px;
  }
`;
